"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Apple = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Apple = function Apple() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.012 5.491c.136.12.317.175.497.15a4.88 4.88 0 003.01-1.858A5.588 5.588 0 0016.717.629a.612.612 0 00-.756-.612A5.78 5.78 0 0013 1.887a5.24 5.24 0 00-1.199 3.13.623.623 0 00.211.474zm8.822 3.19c-.71.666-1.826 1.714-1.826 3.94a5.324 5.324 0 002.83 4.748.612.612 0 01.36.551c0 .084-2.519 6.08-5.54 6.08-.662 0-1.103-.209-1.586-.437-.585-.276-1.232-.582-2.407-.582-1.16 0-1.808.297-2.405.57-.508.233-.98.449-1.697.449-2.782 0-6.559-5.828-6.559-11.092a7.962 7.962 0 011.067-4.245A6.188 6.188 0 018.06 5.629c.973 0 1.77.287 2.524.558.676.243 1.317.473 2.02.473.672 0 1.214-.21 1.808-.44.722-.28 1.522-.59 2.725-.59 2.195 0 4.27 1.582 4.27 2.29 0 .224-.243.452-.573.762z",
    clipRule: "evenodd"
  });
};

exports.Apple = Apple;